<template>
  <div class="daham-school">
    <!-- Hero Section -->
    <section class="hero text-white text-center d-flex align-items-center">
      <div class="container">
        <h1 class="fw-bold display-5">Daham School</h1>
        <p class="lead">
          Nurturing young minds with Buddhist values, discipline, and wisdom.
        </p>
      </div>
    </section>

    <!-- About Section -->
    <!-- Classes Section -->
    <section class="bg-light py-5">
      <div class="container">
        <h2 class="text-center fw-bold mb-5">Our Programs</h2>
        <div class="row g-4">
          <!-- Exam Information -->
          <div class="col-md-4">
            <div class="card h-100 shadow-sm text-center p-4">
              <i class="bi bi-file-earmark-text display-5 text-warning"></i>
              <h5 class="mt-3 fw-bold">Exam Information</h5>
              <p>
                We prepare students for Daham School examinations conducted
                annually. Special revision classes, past paper discussions, and
                guidance are provided to help students achieve excellent
                results.
              </p>
            </div>
          </div>

          <!-- Youth Society -->
          <div class="col-md-4">
            <div class="card h-100 shadow-sm text-center p-4">
              <i class="bi bi-people display-5 text-warning"></i>
              <h5 class="mt-3 fw-bold">Youth Society</h5>
              <p>
                Our Youth Society encourages leadership, teamwork, and social
                service. Students participate in religious programs, community
                activities, and spiritual development workshops.
              </p>
            </div>
          </div>

          <!-- Students Award -->
          <div class="col-md-4">
            <div class="card h-100 shadow-sm text-center p-4">
              <i class="bi bi-award display-5 text-warning"></i>
              <h5 class="mt-3 fw-bold">Students Awards</h5>
              <p>
                Outstanding students are recognized annually for academic
                excellence, discipline, and dedication to Dhamma activities.
                Certificates and special awards are presented at prize-giving
                ceremonies.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "DahamSchool",
};
</script>

<style lang="scss" scoped>
.hero {
  background: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),
    url("@/assets/dahamschool/dahamschool.jpeg") center/cover;
  height: 60vh;
}

.card {
  transition: 0.3s;
}

.card:hover {
  transform: translateY(-5px);
}
</style>
